<template>
  <div>
    <div class="px-4 pb-2">
      <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            label="Picker without buttons"
            prepend-inner-icon="mdi-calendar"
            solo
            readonly
            hide-details
            v-on="on"
            :loading="loading"
          >
          </v-text-field>
        </template>
        <v-date-picker v-model="date" @input="menu2 = false" no-title :locale="$i18n.locale"></v-date-picker>
      </v-menu>
    </div>

    <div class="px-2">
      <chart-line :chart-data="lineData"></chart-line>
    </div>

    <v-card
      class="mx-auto legend-card"
      outlined
    >
      <v-card-text>
        <v-row>
          <v-col cols="6" v-for="(item, i) in toShow" :key="i" class="py-1">
            <v-chip pill @click="toggleShow(item)" :class="{ inactive: !show[item] }">
              <v-avatar
                left
                :color="colors[item]"
              >
              </v-avatar>
              {{ $t(item) }}
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!--<v-container fluid class="legend-container">
      <v-row class="pxx-2">
        <v-col cols="6" v-for="(item, i) in toShow" :key="i" class="py-1">
          <v-chip pill @click="toggleShow(item)" :class="{ inactive: !show[item] }">
            <v-avatar
              left
              :color="colors[item]"
            >
            </v-avatar>
            {{ $t(item) }}
          </v-chip>
        </v-col>
      </v-row>
    </v-container>-->

  </div>
</template>

<script>
import ChartLine from '@/components/ChartLine.vue'
import { mapActions, mapGetters } from 'vuex';
//import { i18n } from '@/i18n.js'

export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    labels: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
    menu: false,
    modal: false,
    menu2: false,
  }),
  computed: {
    ...mapGetters({data: 'temperature/data', show: 'temperature/show', loading: 'temperature/loading'}),
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    colors_() { 
      return (this.$vuetify.theme.dark) 
      ? { temp1: '#ef5350', temp2: '#FF80AB', temp3: '#64b5f6', temp4: '#82B1FF', temp5: '#1E88E5', temp6: '#FF9E80', temp7: '#FFFF8D', temp8: '#FDD835', temp9: '#F4FF81', temp10: '#69F0AE', temp11: '#66BB6A', temp12: '#D7CCC8', temp13: '#B0BEC5', temp14: '#BDBDBD'} 
      : { temp1: 'rgba(239, 48, 36, 0.5)', temp2: '#FF4081', temp3: '#64b5f6', temp4: 'rgba(33, 150, 243, 0.5)', temp5: '#7C4DFF', temp6: '#FF9E80', temp7: 'rgba(255, 235, 59, 0.5)', temp8: '#FFC107', temp9: '#F4FF81', temp10: 'rgba(255, 235, 59, 0.5)', temp11: '#CDDC39', temp12: '#607D8B', temp13: '#FF9800', temp14: '#FF6E40'}
    },
    colors() { 
      return (this.$vuetify.theme.dark) 
      ? { temp1: '#ef5350', temp2: '#FF80AB', temp3: '#64b5f6', temp4: '#82B1FF', temp5: '#1E88E5', temp6: '#FF9E80', temp7: '#FFFF8D', temp8: '#FDD835', temp9: '#F4FF81', temp10: '#69F0AE', temp11: '#66BB6A', temp12: '#D7CCC8', temp13: '#B0BEC5', temp14: '#BDBDBD'} 
      : { temp1: '#ef3024', temp2: '#FF4081', temp3: '#64b5f6', temp4: '#2196F3', temp5: '#7C4DFF', temp6: '#FF9E80', temp7: '#FFEB3B', temp8: '#FFC107', temp9: '#F4FF81', temp10: '#00E676', temp11: '#CDDC39', temp12: '#607D8B', temp13: '#FF9800', temp14: '#FF6E40'}
    },
    datasets() {
      //return Object.keys(this.data).map((item) => {
      return Object.keys(this.show).filter(item => this.show[item] == true && this.data[item]).map((item) => {
        return {
          label: this.$t(item),
          fill: false,
					backgroundColor: this.colors[item],
          borderColor: this.colors[item],
          borderWidth: 3,
          pointRadius: 0,
          spanGaps: true,
					data: this.data[item],
        }
      });
    },
    toShow() {
      return Object.keys(this.data);
    },
    lineData() {
      return {
        labels: this.labels,
        datasets: this.datasets
      };
    }
  },
  watch: {
    date: function (val) {
      this.loadTemperatures();
    }
  },
  created () {
    this.loadTemperatures()
    .then(res => {
       if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
       }
    });
  },
  components: {
    ChartLine
  },
  methods: {
    //...mapActions('temperature', { load: 'load' }),
    ...mapActions('temperature', ['load', 'toggleShow']),
    loadTemperatures() {
      return this.load({controllerId:this.controllerId, date: this.date})
    }
  }
}
</script>

<style>
.legend-card {
  padding-top: 6px !important;
  padding-bottom: 80px !important;
  border-radius: 20px 20px 0 0;
}
canvas {
  width: 100% !important;
  height: auto;
}
.theme--dark.v-chip:not(.v-chip--active) {
  background: #2d2d2d;
}
.v-chip.inactive .v-avatar {
  background-color: rgba(0,0,0,0.0) !important;
  display: none;
}
.theme--light.v-chipp:not(.v-chip--active) {
  background: #fff;
  -webkit-box-shadow: 0px 5px 20px -5px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 20px -5px rgba(0, 0, 0, 0.15);
}
</style>

<i18n>
{
  "pl": {
    "temp1": "Kocioł",
    "temp2": "Kocioł/zadana",
    "temp3": "Spaliny",
    "temp4": "CW",
    "temp5": "CW/zadana",
    "temp6": "Podajnik",
    "temp7": "Zawór",
    "temp8": "Zawór/zadana",
    "temp9": "Powrót",
    "temp10": "Podłoga",
    "temp11": "Podłoga/zadana",
    "temp12": "Temp. zewn.",
    "temp13": "Temp. wewn.",
    "temp14": "Wewn./zadana"
  },
  "en": {
    "temp1": "Kocioł",
    "temp2": "Kocioł/zadana",
    "temp3": "Spaliny",
    "temp4": "CW",
    "temp5": "CW/zadana",
    "temp6": "Podajnik",
    "temp7": "Zawór",
    "temp8": "Zawór/zadana",
    "temp9": "Powrót",
    "temp10": "Podłoga",
    "temp11": "Podłoga/zadana",
    "temp12": "Temp. zewn.",
    "temp13": "Temp. wewn.",
    "temp14": "Wewn./zadana"
  }
}
</i18n>